export function groupBy<T>(items: T[], selector: (item: T) => (string | number)): { [key: (string | number)]: T[] } {
  const result: { [key: (string | number)]: T[] } = {};

  for (const item of items) {
    const key = selector(item);

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  }

  return result;
}
